import capitalize from "lodash/capitalize";

import getModal from "../../lib/getModal";

const onChangeConsumer = (array, modal = true) => {
  // Bug real (auditoría 2026-08-14): array[0] puede ser una referencia
  // DIRECTA a un objeto cacheado por react-query (ej. Select.js pasa
  // options={query.data.flat()} — cada opción es el consumer tal cual vive
  // en la cache). Mutarlo acá (como hacía antes) corrompía esa cache: otra
  // pantalla que muestre el mismo resultado de búsqueda vería los cambios
  // de este picker sin que nadie los haya guardado. Se trabaja sobre una
  // copia.
  const consumer = { ...(array[0] || {}) };
  consumer.financiers = consumer.financiers || [];
  consumer.label = consumer.label || "";
  // Bug real (auditoría 2026-08-14): .filter(Boolean) ANTES de la
  // destructuración posicional corría el riesgo de correr los valores — un
  // label "{, Juan}" (apellido vacío, solo nombre) da split→["", "Juan"],
  // y filtrar el "" corrido dejaba ["Juan"] destructurado como
  // lastName="Juan"/firstName="" — invirtiendo nombre y apellido.
  const [lastName = "", firstName = ""] = consumer.label
    .split(",")
    .map((p) => p.trim());
  if (consumer.customOption || !consumer.id || /^new/.test(consumer.id)) {
    delete consumer.id;
    if (/^\d/.test(consumer.label)) {
      consumer.identification = consumer.label
      if (modal) getModal("consumersModal", true, {
        identification: consumer.identification,
      }).show();
    } else {
      consumer.lastName = lastName.split(" ").map(capitalize).join(" ")
      consumer.firstName = firstName.split(" ").map(capitalize).join(" ")
      if (modal) getModal("consumersModal", true, {
        lastName: consumer.lastName,
        firstName: consumer.firstName,
      }).show();
    }
  }

  consumer.lastName = lastName;
  consumer.firstName = firstName;
  consumer.label = [lastName, firstName].filter(Boolean).join(", ");

  return consumer;
};

export default onChangeConsumer;
